import { getCommentIconsByTriggerElement } from './getCommentIconsByTriggerElement';

export const toggleUnreadIndicator = ({
    triggerElement,
    shouldShow,
    enableRemoveIndicator = false,
}: {
    triggerElement: Element;
    shouldShow: boolean;
    enableRemoveIndicator?: boolean;
}): void => {
    const { commentActionIcon, positionCommentIcon } =
        getCommentIconsByTriggerElement(triggerElement);

    if (!commentActionIcon) {
        return;
    }

    const indicator = commentActionIcon.querySelector('.comments-unread-indicator');

    if (shouldShow) {
        commentActionIcon.classList.add('has-unread-comments');
        commentActionIcon.classList.remove('has-no-comments');
        positionCommentIcon?.classList.remove('has-no-comments');

        if (!indicator) {
            const nextIndicator = document.createElement('span');
            nextIndicator.className = 'comments-unread-indicator';
            commentActionIcon.appendChild(nextIndicator);
        }

        return;
    }

    if (enableRemoveIndicator) {
        commentActionIcon.classList.remove('has-unread-comments');
        indicator?.remove();
    }
};
